// extracted by mini-css-extract-plugin
export default {"root":"gift_card_store_booking_confirmation_page_root__F89VV","loadingContainer":"gift_card_store_booking_confirmation_page_loadingContainer__MwksA"};